<template>
  <div :class="[classDiv,'placeholder-glow']">
    <div :class="['form-floating', 'mb-3']">
      <textarea :type="tipo" :class="['form-control', tam_input, class_placeholder]" :name="nome" :id="nome" :aria-describedby="id_descr"
        :placeholder="placeholder" :value="modelValue" @input="$emit('update:modelValue', $event.target.value)"
        :disabled="desabilitado" style="height: 140px"></textarea>
      <tooltips>
        <span v-html="btn_tooltip"></span>
      </tooltips>
      <label :for="(id ? id : '')" v-if="label" class="form-label">
        {{ label }}
      </label>
      <div :id="id_descr" v-if="descricao" class="form-text">
        {{ descricao }}
      </div>
    </div>
  </div>
</template>

<script>
import Tooltips from '../Tooltips.vue';
export default {
  name: "InputTextarea",
  props: {
    tipo: {
      default: "text",
    },
    tamanho: {
      default: "",
    },
    nome: {
      default: "nome",
    },
    desabilitado: {
      default: false,
    },
    ativa_placeholder: {
      default: false,
    },
    placeholder: '',
    modelValue: '',
    classDiv: String,
    label: String,
    id: String,
    id_descr: String,
    descricao: String,
    tooltip: String,
    tooltip_direcao: {
      default: "top",
    },
  },
  emits: ['update:modelValue'],
  components: { Tooltips },
  data() {
    return {
      model: "",
    };
  },
  computed: {
    tam_input: function () {
      if (this.tamanho == "") {
        return "";
      } else {
        return "form-control-" + this.tamanho;
      }
    },
    btn_tooltip: function () {
      if (this.tooltip != undefined) {
        return `<button type="button" class="border-0" data-bs-toggle="tooltip" data-bs-placement="` + this.tooltip_direcao + `"
                  data-bs-title="`+ this.tooltip + `">
                  <i class="bi bi-info-circle"></i>
                </button>`
      }
    },
    class_placeholder: function(){
      return (this.ativa_placeholder ? 'placeholder' : '')
    }
  },
  mounted() {

  },
};
</script>

<style scoped>
label {
  font-size: 1rem !important;
  color: #999
}
</style>